import { render } from "./CountryStorage.vue?vue&type=template&id=79839732&scoped=true"
import script from "./CountryStorage.vue?vue&type=script&lang=js"
export * from "./CountryStorage.vue?vue&type=script&lang=js"

import "./CountryStorage.vue?vue&type=style&index=0&id=79839732&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79839732"]])

export default __exports__